((section_name) => {
  const selectors = {
    shopifySection: ".shopify-section",
    time: ".countdown__datetime",
    hours: "[data-hours]",
    minutes: "[data-minutes]",
    seconds: "[data-seconds]",
  };

  const attributes = {
    expirationBehavior: "data-expiration-behavior",
    countdownHours: "data-countdown-hours",
  };

  const classes = {
    showMessage: "show-message",
    hideCountdown: "hidden",
  };

  const settings = {
    hideSection: "hide-section",
    showMessage: "show-message",
  };

  let ACC_ND_CountdownTimer = class ACC_ND_CountdownTimer extends HTMLElement {
    connectedCallback() {
      // Initialize timer with stored or new end time
      this.initializeTimer();

      if (isNaN(this.endDate)) {
        this.onComplete();
        this.showTimer();
        return;
      }
      if (this.endDate <= Date.now()) {
        this.onComplete();
        this.showTimer();
        return;
      }

      // Show correct time immediately
      this.update();
      this.showTimer();

      // Update the countdown every second
      this.interval = setInterval(this.update, 1000);
    }

    showTimer() {
      const digits = this.querySelectorAll(".timer__digit");

      digits.forEach((digit) => {
        const loader = digit.querySelector(".countdown__loader");
        const digitValue = digit.querySelector(".timer__digit-value");

        if (loader) {
          loader.style.display = "none";
        }
        if (digitValue) {
          digitValue.style.display = "block";
        }
        digit.style.display = "flex";
      });
    }

    initializeTimer() {
      const storageKey = `${section_name}_countdown_${this.sectionId}`;
      const stored = localStorage.getItem(storageKey);
      const now = Date.now();

      if (stored) {
        const storedData = JSON.parse(stored);
        if (storedData.endDate > now) {
          // Use stored end date if it's still in the future
          this.endDate = storedData.endDate;
          return;
        }
      }

      // Calculate new end date based on countdown hours
      const hoursInMs = this.countdownHours * 60 * 60 * 1000;
      this.endDate = now + hoursInMs;

      // Store the new end date
      localStorage.setItem(
        storageKey,
        JSON.stringify({
          endDate: this.endDate,
          startDate: now,
        })
      );
    }
    disconnectedCallback() {
      this.stopTimer();
    }
    convertTime(timeInMs) {
      const hours = this.formatDigits(parseInt(timeInMs / this.hoursInMs, 10));
      timeInMs -= hours * this.hoursInMs;
      const minutes = this.formatDigits(
        parseInt(timeInMs / this.minutesInMs, 10)
      );
      timeInMs -= minutes * this.minutesInMs;
      const seconds = this.formatDigits(
        parseInt(timeInMs / this.secondsInMs, 10)
      );
      return {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
      };
    }
    // Make numbers with leading zero
    formatDigits(number) {
      return number.toString().padStart(2, "0");
    }
    render(timer) {
      const hoursValue = this.hours.querySelector(".timer__digit-value");
      const minutesValue = this.minutes.querySelector(".timer__digit-value");
      const secondsValue = this.seconds.querySelector(".timer__digit-value");

      if (hoursValue) hoursValue.textContent = timer.hours;
      if (minutesValue) minutesValue.textContent = timer.minutes;
      if (secondsValue) secondsValue.textContent = timer.seconds;
    }
    stopTimer() {
      clearInterval(this.interval);
    }
    onComplete() {
      this.render({
        hours: "00",
        minutes: "00",
        seconds: "00",
      });

      // Clear stored countdown data
      const storageKey = `${section_name}_countdown_${this.sectionId}`;
      localStorage.removeItem(storageKey);

      if (this.shouldHideOnComplete) {
        this.shopifySection.classList.add(classes.hideCountdown);
      }
      if (this.shouldShowMessage) {
        this.classList.add(classes.showMessage);
      }
    }
    // Function to update the countdown
    update() {
      const timeNow = new Date().getTime();
      const timeDiff = this.endDate - timeNow;
      if (timeDiff <= 0) {
        this.stopTimer();
        this.onComplete();
      }
      const timeRemaining = this.convertTime(timeDiff);
      this.render(timeRemaining);
    }
    constructor() {
      super();
      this.shopifySection = this.closest(selectors.shopifySection);
      this.sectionId = this.shopifySection ? this.shopifySection.id : "default";
      this.expirationBehavior = this.getAttribute(
        attributes.expirationBehavior
      );
      this.countdownHours = Math.min(
        Math.max(
          parseInt(this.getAttribute(attributes.countdownHours)) || 2,
          1
        ),
        24
      );

      this.time = this.querySelector(selectors.time);
      this.hours = this.querySelector(selectors.hours);
      this.minutes = this.querySelector(selectors.minutes);
      this.seconds = this.querySelector(selectors.seconds);

      this.daysInMs = 1000 * 60 * 60 * 24;
      this.hoursInMs = this.daysInMs / 24;
      this.minutesInMs = this.hoursInMs / 60;
      this.secondsInMs = this.minutesInMs / 60;

      this.shouldHideOnComplete =
        this.expirationBehavior === settings.hideSection;
      this.shouldShowMessage = this.expirationBehavior === settings.showMessage;
      this.update = this.update.bind(this);
    }
  };

  // Register custom element if not already defined
  if (!customElements.get("acc-nd-countdown-timer")) {
    customElements.define("acc-nd-countdown-timer", ACC_ND_CountdownTimer);
  }
})("acc_nd_landing_10_01");
